export enum LogDetailsItemType {
  POOL_TRIGGER = 'Trigger',
  SCHEDULED_EVENT = 'Scheduled event',
}